import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import Hero from '../../sections/Hero';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const MovingServicePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Moving Company Northeast Wisconsin</title>
        <meta
          name="description"
          content="Your reliable moving company in Northeast Wisconsin. JBR Delivery LLC provides professional residential and commercial moving services in Green Bay, Appleton, and the Fox Valley."
        />
        <meta
          name="keywords"
          content="moving company Northeast Wisconsin, movers Green Bay, movers Appleton, residential moving, commercial moving, Fox Valley movers, JBR Delivery LLC"
        />
        {/* Schema.org markup for Moving Service */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Service",
              "serviceType": "Moving Company",
              "provider": {
                "@type": "MovingCompany",
                "name": "JBR Delivery LLC",
                 "areaServed": {
                   "@type": "Place",
                   "name": "Northeast Wisconsin"
                 },
                "telephone": "(920) 255-8952"
              },
              "areaServed": {
                 "@type": "Place",
                 "name": "Northeast Wisconsin"
               },
              "name": "Professional Moving Services",
              "description": "Comprehensive moving services for homes and businesses throughout Northeast Wisconsin, including Green Bay and Appleton. Trust JBR Delivery LLC, your local moving company."
            }
          `}
        </script>
      </Helmet>

      <Hero 
        title="Northeast Wisconsin Moving Company"
        subtitle="Stress-free moving solutions for homes and businesses in Green Bay, Appleton, and the surrounding Northeast Wisconsin area."
        backgroundImage="/assets/images/moving-service-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom>
            Your Trusted Moving Company in Northeast Wisconsin 
          </Typography>
          <Typography variant="body1" paragraph>
            JBR Delivery LLC is your go-to moving company in Northeast Wisconsin. We offer comprehensive moving services designed to make your transition smooth and stress-free. Whether you're moving locally within Green Bay, relocating to Appleton, or anywhere in the Fox Valley, our trained professionals handle your belongings with the utmost care.
          </Typography>
          <Typography variant="body1" paragraph>
            As experienced movers in Northeast Wisconsin, we cater to both residential and commercial clients. From apartments and houses to office spaces, our team has the expertise and equipment for moves of all sizes. We provide packing, loading, transportation, and unpacking services tailored to your specific needs. Choose JBR Delivery LLC for reliable and affordable moving solutions.
          </Typography>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default MovingServicePage;
